import React from 'react';
import UserHelper from '../../../helper/user.js'
import Row from './children/row.js'

export default{
  RenderRegisterButton(self,permission,UserReducer,callback){
    if(!UserHelper.HasPermission(permission,UserReducer)){
      return
    }
    return(
      <div className="float-right">
        <button type="button" className="btn btn-sm btn-primary" onClick={callback}><i className="fa fa-dot-circle-o"></i> Add New User</button>
      </div>
    )
  },
  RenderMasterAutoComplete(MasterReducer,with_key = false){
    if(MasterReducer.rs == null){
      return
    }
    var Option = []
    for(var i = 0 ; i < MasterReducer.rs.length;i++){
      if(with_key){
        Option.push(
          { value: MasterReducer.rs[i].Alias, label: MasterReducer.rs[i].Name }
        )
      }else{
        Option.push(
          { value: MasterReducer.rs[i].Name, label: MasterReducer.rs[i].Name }
        )
      }
    }
    return Option
  },
  RenderRecord(self){
    if(self.props.Reducer.rs === null){
      return
    }
    var rs = []
    for (var i = 0 ; i < self.props.Reducer.rs.length;i++){
        rs.push(
          <Row Data={self.props.Reducer.rs[i]} self={self} key={i}/>
        )
    }
    return rs
  },
  RenderPagination(Reducer,next_action,previous_action,next_props,previous_props){
    var jsx = [];

    // if(Reducer.previous !== null){
    //   jsx.push(
    //     <li className="page-item" key={'previous'}><a role="button" tabIndex="0" className="page-link" onClick={()=>previous_action(previous_props)}>Previous</a></li>
    //   )
    // }
    if(Reducer.next !== null){
      jsx.push(
        <div><button className="btn btn-primary" onClick={()=>next_action(next_props)}>Load More</button></div>
      )
    }
    return jsx;
  }
}



// WEBPACK FOOTER //
// ./src/App/user/model/helper/render.js